<script setup lang="ts">
import BaseInput, { BaseInputProps } from '@/atoms/BaseInput.vue';
import LocalIcon from '@/atoms/LocalIcon.vue';
import { computed, ref } from 'vue';
import BaseLabel from '@/atoms/BaseLabel.vue';
import { Capacitor } from '@capacitor/core';
import { Keyboard } from '@capacitor/keyboard';

export type DropdownItem = {
  label: string;
  key: string | number;
  value?: unknown;
  iconName?: string;
};

export type BaseDropdownProps = BaseInputProps & {
  class?: string;
  items: DropdownItem[];
  label?: string;
};
const props = defineProps<BaseDropdownProps>();

const toggled = ref(false);
const selectedKey = defineModel<string>();

const selectedItem = computed(() => {
  return props.items.find((item) => String(item.key) === selectedKey.value);
});
</script>

<template>
  <BaseInput
    v-bind="props"
    :class="props.class"
    tabindex="0"
    class="relative"
    :id="id"
    @click="toggled = !toggled"
    @blur="toggled = false"
    type="text"
  >
    <div>
      <BaseLabel
        preset="medium"
        :text="selectedItem?.label ?? props.label ?? ''"
        :color="selectedItem ? 'primary' : 'placeholder'"
      />
      <div
        v-if="toggled"
        class="w-80 max-h-80 px-1.5 absolute top-full left-0 bg-bg-primary rounded-lg flex flex-col border border-primary py-1 overflow-y-auto z-50 shadow-lg"
      >
        <div
          class="flex items-center w-80 px-2 py-2 space-x-2"
          v-for="item in props.items"
          @click="selectedKey = String(item.key); if (Capacitor.isNativePlatform()) Keyboard.hide()"
          :key="item.label"
          :data-cy="`${id}-select-${String(item.key)}`"
        >
          <LocalIcon class="text-secondary" :name="item.iconName ?? 'plus'" />
          <BaseLabel :text="item.label" preset="medium" color="primary" />
        </div>
      </div>
    </div>
    <template #right-slot>
      <LocalIcon name="chevron-down" />
    </template>
  </BaseInput>
</template>
